import type { NodeId } from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';
import type { Draft } from 'immer';

export const removeNodeFromState =
  (draftState: Draft<GraphData>) =>
  (nodeId: NodeId): void => {
    delete draftState.nodes[nodeId];
    draftState.selectedNodeIds.delete(nodeId);
    draftState.hiddenNodes.delete(nodeId);
  };
